module.exports = __webpack_public_path__ + "static/media/band.c8837a4c.m4a";